import { UserConsentForm } from 'components/Blocks/UserConsent/UserConsentForm/UserConsentForm';
import { useUserConsent } from 'components/Blocks/UserConsent/useUserConsent';
import { showSuccessMessage } from 'components/Helpers/Toasts';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { FormProvider } from 'react-hook-form';

export const UserConsentInPageContainer: FC = () => {
    const { t } = useTranslation();
    const { push: routerPush } = useRouter();

    const onSaveCallback = useCallback(async () => {
        showSuccessMessage(t('Your cookie preferences have been set.'));
        await routerPush('/');
    }, [routerPush, t]);

    const {
        cookiePolicyUrl,
        formProviderMethods,
        onAcceptAllCallback,
        onRejectAllCallback,
        onSaveCookieChoicesCallback,
    } = useUserConsent(onSaveCallback);

    return (
        <FormProvider {...formProviderMethods}>
            <UserConsentForm
                cookiePolicyUrl={cookiePolicyUrl}
                onAcceptAllCallback={onAcceptAllCallback}
                onRejectAllCallback={onRejectAllCallback}
                onSaveCookieChoicesCallback={onSaveCookieChoicesCallback}
            />
        </FormProvider>
    );
};
